import React, { Fragment } from 'react'
import Fade from 'react-reveal/Fade';

const ServicioIconBlock = (props) => {
	return (
		<Fragment>
			<Fade bottom>
				<div className="item">
					<figure>
						<div className="icon">
							<img
								src={props.imgsrc}
								alt={props.titulo}
								className="img-fluid mx-auto d-block"
							/>
						</div>
						<figcaption>
							<h2>{props.titulo}</h2>
							{props.descripcion ? <p>{props.descripcion}</p> : null}
						</figcaption>
					</figure>
				</div>
			</Fade>
		</Fragment>
	)
}

export default ServicioIconBlock
